import { VCheckbox } from 'vuetify/lib/components/VCheckbox';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCheckbox,_vm._b({attrs:{"label":((_vm.$t('Include deleted')) + " " + (_vm.$t(_vm.value.reportType || 'orders'))),"hide-details":"auto"},on:{"change":function($event){_vm.paramsWith = !_vm.paramsWith}},model:{value:(_vm.paramsWith),callback:function ($$v) {_vm.paramsWith=$$v},expression:"paramsWith"}},'v-checkbox',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }